export default {
	service: [
		"Сервис",
		"Событие",
		"Вывод средств",
		"Депозит",
		"Условия и положения",
		"Сертификат",
		"Часто задаваемые вопросы",
		"Руководство пользователя",
		"VIP"
	],
	sign: {
		title: "Вход в течение {0} дня",
		SignIn: "Войти"
	},
	hotMusicAlbum: "Горячий музыкальный альбом",
	hotMusic: "Горячие музыкальные чарты",
	popular: "Новое воспроизведение",
	rankings: "Популярные фильмы",
	top: "ТОП{0}",
	OnchainServices: "Ончейн-сервисы",
	Real: {
		title: "В реальном времени",
		list: [
			"Общее количество пользователей онлайн",
			"Средний объем оптимизации пользователя",
			"Тепловая карта потребностей в оптимизации",
			"Количество оптимизаций продвижения платформы"
		]
	},
	work: {
		title: "Вознаграждение за размещение заказа",
		SignIn: "Получить"
	},
	Profit: {
		Profit: "Прибыль",
		tabs: ["Прибыль", "Бонус", "Аккаунт"],
		TotalBalance: "Общий баланс",
		TotalLuckyBonus: "Общий Счастливый Бонус",
		todayEarnings: "Сегодняшний Доход",
		availableBalance: "Доступный баланс",
		title: ["Сегодняшний Доход", "Общий Доход", "Аккаунт"],
		list: ["Доход от Заказов", "Доход Команды", "Общий Доход"],
		order: {
			title: "Прибыль от Заказа",
			commission: "Комиссия за Заказ"
		},
		Analysis: {
			title: "Анализ Прибыли",
			tips: "Вы совершили {0} транзакций",
			tabs: ["Сегодняшняя Прибыль", "Общая Прибыль"],
			totalTitle: ["Прибыль от Заказа", "Прибыль от Регистрации", "Прибыль Команды", "Прибыль от Бонуса"]
		}
	},
	CustomerService: {
		title: "Центр Обслуживания Клиентов",
		consultation: "Консультация Службы Поддержки",
		btn: "Свяжитесь с нами",
		noticeTitle: "Системное Уведомление"
	},
	addWallet: "Добавить кошелек",
	taskProgress: "Прогресс ежедневных задач",
	currentProgress: "Текущий прогресс задачи",
	awardsBulletin: `{0} пользователь выигрывает {1} {2} приз в задаче.`,
	vip: {
		title: "@:vip.title",
		more: "Показать больше"
	},
	stats: {
		title: "Источники данных - Панель управления и API",
		subTitle: "Статистика артистов",
		list: ["Метрики", "Артисты с активными социальными сетями", "Обновляется ежедневно"]
	}
};
